<template>
  <a-row>
    <a-col :span="labelCol">
      <div class="label-title">{{ title }}</div>
    </a-col>
    <a-col :span="valueCol">
      <a-form-item v-bind="validate">
        <a-date-picker
            style="width: 100%"
            v-model:value="inputValue"
            @change="onChange"
            allowClear
            :picker="picker"
            :disabled="disabled"
            :showTime="showTime"
          />

        <span v-if="validate" class="must">*</span>
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'

import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'

export default defineComponent({
  props: {
    value: {
      type: Object,
      default: () => {}
    },

    title: {
      type: String,
      default: '标题'
    },

    labelCol: {
      type: Number,
      default: 4
    },

    valueCol: {
      type: Number,
      default: 16
    },

    validate: {
      type: Object,
      default: () => null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    showTime: {
      type: Boolean,
      default: false
    },

    picker: {
      type: String,
      default: 'date'
    }
  },
  setup (props, { emit }) {
    const inputValue = ref(props.value)

    watch(props, (e) => {
      inputValue.value = e.value
    })

    const onChange = (e) => {
      console.log(e)
      emit('update:value', e)
    }

    return {
      inputValue,
      locale,
      onChange
    }
  }
})
</script>

<style lang="less" scoped>
.must {
  position: absolute;
  top: 0;
  right: -10px;
  color: #f00;
  font-size: 18px;
  line-height: 32px;
}
</style>
